const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const UpdatePulseMKeys = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_PULSEM_KEYS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_PULSEM_KEYS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default UpdatePulseMKeys;